import React, { Component, Suspense } from "react";
import { Detector } from "react-detect-offline";
import axios from "../../axios";
import * as url from "../../utils/url";
import * as actionCreators from "./../../modules/actions/index";
import NavBar from "../../components/NavBar/NavBar";
import SideBar from "../../components/SideBar/SideBar";
import { isMobile } from "../../utils/deviceInfo";
import {
  navigate_user_to_module,
  custom_views,
  planningValues,
  resizeImageFromUrl,
  isTrivvyProduct,
  isTrivvyUrl,
} from "../../utils/constants";

import If from "../../components/Shared/If";
import MemberSideBar from "../../components/SideBar/MemberSideBar";

import MemberActivityBar from "../../components/SideBar/MemberActivityBar";
import ActivityBar from "../../components/SideBar/ActivityBar";
import trivvyLogo from "./../../assets/trivvy/trivvy-logo-img.png";

import moment from "moment"
import {
  Switch,
  Route,
  withRouter,
  Navigate,
  Redirect,
} from "react-router-dom";
import { connect } from "react-redux";
import "./Home.css";
import AddToolkit from "../../pages/toolkit/AddToolkit";
import EditToolkit from "../../pages/toolkit/EditToolkit";
import ToolDetails from "../../pages/toolkit/ToolDetails/Details/ToolDetails";
import ViewToolkit from "../../pages/toolkit/ViewToolkit";
import ChooseToolkitCategory from "../../pages/toolkit/ChooseToolkitCategory";
import ToolkitCategory from "../../pages/toolkit/ToolkitCategory";
import ToolPreview from "../../pages/toolkit/ToolDetails/Preview/Preview";
import Help from "../../pages/help/Help";
import Terms from "../../pages/terms/Terms";
import ChooseAnalyticsCategory from "../../pages/analytics/ChooseCategory/ChooseAnalyticsCategory";
import CreateChart from "../../pages/analytics/CreateChart/CreateChart";
// import EditChart from '../../pages/analytics/EditChart/EditChart';
import ChartList from "../../pages/analytics/ChartList/ChartList";
import ViewChart from "../../pages/analytics/ViewChart/ViewChart";

import Dani from "../../pages/dani/Dani";
import OfficeMates from "../../pages/office/OfficeMates/OfficeMates";
import Users from "../../pages/user/Users/Users";
import InviteOfficeMates from "../../pages/office/InviteOfficeMates/InviteOfficeMates";
import OfficeMateProfile from "../../pages/office/OfficeMateProfile/OfficeMateProfile";
import AddMembers from "../../pages/setup/office/AddMembers";
import ProfilePage from "../../pages/office/OfficeMateProfile/usersProfile";
import UserProfile from "../../pages/user/UserProfile/UserProfile";
import WeeklyWins from "../../pages/weekly-wins/WeeklyWins";
import SingleTask from "../../pages/weekly-wins/SingleTask";

import EnterpriseObjective from "../../pages/enterpriseObjective/EnterpriseObjective";
import Hotjar from "@hotjar/browser";

// ImportHistory
import ImportHistory from "../../pages/enterprise/ImportHistory";
import MetaDataHistory from "../../pages/trivia/metaDataHistory/metaDataHistory"

import Stories from "../../pages/stories/Stories";
import MyStories from "../../pages/stories/MyStories";
import Announcements from "../../pages/announcements/CurrentAnnouncement";

import ArchivedStories from "../../pages/stories/ArchivedStories";
import StoriesTypes from "../../pages/stories/StoriesTypes";
import StoryCreate from "../../pages/stories/StoryCreate";
import SingleStory from "../../pages/stories/SingleStory";
import StoryItems from "../../pages/stories/StoryItems";

import Trending from "../../pages/stories/Trending";

import Notifications from "../../pages/notifications/Notifications";

import EnterpriseAssociatedActions from "../../pages/enterpriseAssociatedActions/EnterpriseActions";
import OfficeInformation from "../../pages/office/OfficeInformation/OfficeInformation";
import OrgChartManagement from "../../pages/enterprise/OrgChartManagement/OrgChartManagement";
import ChooseUploadCategory from "../../pages/upload-data/ChooseUploadCategory";
import CsvUpload from "../../pages/upload-data/Csv/CsvUpload";
import ManualDataEntry from "../../pages/upload-data/Manual/ManualDataEntry";
import UploadSuccess from "../../pages/upload-data/UploadSuccess";
import EnterpriseInformation from "../../pages/enterprise/EnterpriseInformation";
import MapGenderManagement from "../../pages/enterprise/MapGenderManagement/MapGenderManagement";
import MapPerformanceManagement from "../../pages/enterprise/MapPerformanceManagement/MapPerformanceManagement";

import GroupList from "../../pages/groups/GroupList";
import SingleGroup from "../../pages/groups/SingleGroup";
import SingleGroupSettings from "../../pages/groups/SingleGroupSettings";
import CreateGroup from "../../pages/groups/CreateGroup";
import SingleGroupPlanning from "../../pages/groups/Pages/GroupPlanning";

import ChangeOfficeSuccess from "../../pages/enterprise/EnterpriseSettings/ChangeOfficeSuccess";
import ImportOfficeHierarchy from "../../pages/enterprise/EnterpriseSettings/ImportOfficeHierarchy";
import ChangeOfficeHierarchy from "../../pages/enterprise/EnterpriseSettings/ChangeOfficeHierarchy";
import OfficeHierarchyManagement from "../../pages/enterprise/EnterpriseSettings/OfficeHierarchyManagement";
import OfficeHierarchyManagementReview from "../../pages/enterprise/EnterpriseSettings/OfficeHierarchyManagementReview";

import MapEthnicityManagement from "../../pages/enterprise/MapEthnicityManagement/MapEthnicityManagement";
import MapVeteranManagement from "../../pages/enterprise/MapVeteranManagement/MapVeteranManagement";
import MapDisabilityManagement from "../../pages/enterprise/MapDisabilityManagement/MapDisabilityManagement";
import MapSexualOrientationManagement from "../../pages/enterprise/MapSexualOrientationManagement/MapSexualOrientationManagement";
import MapReligionManagement from "../../pages/enterprise/MapReligionManagement/MapReligionManagement";

import MapPositionsManagement from "../../pages/enterprise/MapPositionsManagement/MapPositionsManagement";
import MapSeparationManagement from "../../pages/enterprise/MapSeparationManagement/MapSeparationManagement";
import ReviewExistingMappingManagement from "../../pages/enterprise/ReviewExistingMappingManagement/ReviewExistingMappingManagement";
import MapSuccessManagement from "../../pages/enterprise/MapSuccessManagement/MapSuccessManagement";
import NoData from "../../pages/empty-stage/NoData/NoData";

import UserAnalytics from "../../pages/dashboard/UserAnalytics";
import Analytics from "../../pages/dashboard/Analytics";
import AnalyticsToolKit from "../../pages/dashboard/ToolKitAnalytics";
import AnalyticsCharts from "../../pages/dashboard/ChartAnalytics";

import ActionAnalytics from "../../pages/dashboard/ActionAnalytics";
import StoriesAnalytics from "../../pages/dashboard/StoriesAnalytics";
// import ReportLayout from '../../pages/analytics/Dashboard/Reports/ReportLayout';

import DashboardList from "../../pages/analytics/Dashboard/View/DashboardList";
import DashboardCreate from "../../pages/analytics/Dashboard/Create/DashboardCreate";
import ProfileEvents from "../../pages/user/ProfileEvents";
import Metrics from "../../pages/groups/Metrics/Metrics";
import StoryAndComments from "../../pages/reporting/StoryAndComments";
import AllActions from "../../pages/weekly-wins/AllActions";
import TriviaList from "../../pages/trivia/TriviaList";
import TriviaEdit from "../../pages/trivia/TriviaEdit";
import TriviaQuizPage from "../../pages/trivia/Quiz/TriviaQuizPage";
import PreviewQuizPage from "../../pages/trivia/Quiz/PreviewQuizPage";
import TriviaContainer from "../../pages/trivia/TriviaContainer";
import TriviaLibraryViewPage from "../../pages/trivia/LibraryModule/TriviaLibraryViewPage";
import { toastContainer } from "../../utils/toast";
import SchedultTrivvyLoaderBox from "../../pages/trivia/LibraryModule/Components/SchedultTrivvyLoaderBox";
import CreateTrivvyLoaderBox from "../../pages/trivia/LibraryModule/Components/CreateTrivvyLoaderBox";
import GenerateSummaryLoaderBox from "../../pages/trivia/LibraryModule/Components/GenerateSummaryLoaderBox";
import CreateLibraryLoaderBox from "../../pages/trivia/LibraryModule/Components/CreateLibraryLoaderBox";
import DaniTerms from "../../pages/dani/SlackVerificationPages/TermsAndConditionsPage"
import DaniLandingPage from "../../pages/dani/SlackVerificationPages/LandingPage";
import DataPolicies from "../../pages/dani/SlackVerificationPages/DataPolicies";
import SupportPage from "../../pages/dani/SlackVerificationPages/SupportPage";
import DiversityCalendar from "../../pages/DiversityCalendar/DiversityCalendar";
import DEIMaturityModel from "../../pages/DEIMaturityModel/DEIMaturityModel";
// const DashboardList = React.lazy(() => import('../../pages/analytics/Dashboard/View/DashboardList'));
// const DashboardCreate = React.lazy(() => import('../../pages/analytics/Dashboard/Create/DashboardCreate'));

class AdminHome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isStories: true,
      publicObj:
        planningValues.length > 0
          ? planningValues.filter((e) => e.typeOf == "public")[0]
          : [],
    };
  }

  getUrlParameter(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
    var results = regex.exec(this.props.location.search);
    return results === null
      ? ""
      : decodeURIComponent(results[1].replace(/\+/g, " "));
  }

  geolocateUser = () => {
    axios
      .post(url.geolocate, { user: this.props.user, noLoader: true })
      .then(({ data }) => {
        // console.log("login");
      })
      .catch((err) => console.log("err--", err));
  };

  componentDidUpdate(prevProps) {
    if (
      isMobile &&
      this.props.location.pathname !== prevProps.location.pathname
    ) {
      window.scrollTo(0, 0);
      if (this.props.location.pathname.indexOf("dei-maturity-model") == -1) {
        this.props.updateSelectedDate(moment().startOf("day"))
      }
    } else if (
      !isMobile &&
      this.props.location.pathname !== prevProps.location.pathname
    ) {
      if (this.props.location.pathname.indexOf("dei-maturity-model") == -1) {
        this.props.updateSelectedDate(moment().startOf("day"))
      }
      let isStories =
        this.props &&
          this.props.location &&
          this.props.location.pathname == "/home/stories"
          ? true
          : false;
      this.setState({ isStories });
    }
    // console.log("pathname-----", this.props.location.pathname);
    // if( url_check.indexOf(this.props.location.pathname)>-1)
    // this.geolocateUser()login_time
    // /home/toolkit/all, /home/stories, /home/analytics/all,  /home/my-activity
    // if user login_time is greater than or post_login_time ==null, run geolocate
  }

  componentDidMount() {

    if(window.location.hostname === 'trivvy.ouroffice.io'){
      Hotjar.init(4935459, 6, {
        debug: true,
      });
    }

   

    window.addEventListener("beforeunload", this.handleBeforeUnload);
    if (isMobile) window.scrollTo(0, 0);
    let isStories =
      this.props &&
        this.props.location &&
        this.props.location.pathname == "/home/stories"
        ? true
        : false;
    this.setState({ isStories });
  }

  componentWillMount() {
    // const params = new URLSearchParams(this.props.location.search);
    // const notificationId = params.get('notification');
    this.props.setLibraryScheduleLoader({
      display: false,
      loaderApiData: null,
      minimize: false,
    });
    this.props.setCreateTrivvyLoader({
      display: false,
      loaderApiData: null,
      minimize: false,
    });
    this.props.setGenerateSummaryLoader({
      display: false,
      loaderApiData: null,
      minimize: false,
    });
    this.props.setCreateLibraryLoader({
      display: false,
      loaderApiData: null,
      minimize: false,
    });
    axios.interceptors.response.use(
      (res) => {
        return res;
      },
      (error) => {
        if (error && error.response) {
          // console.log("err Home.jsx ---- ", error);
          let { response, message } = error;
          let { data, status } = response;
          if (data === "Unauthorized" && status == 401) {
            this.props.onLogout();
            this.props.history.push("/");
          }
        }

        return Promise.reject(error);
      }
    );

    const notificationId = this.getUrlParameter("notification");

    if (notificationId && notificationId !== null && notificationId !== "") {
      axios
        .get(url.getNotificationDetails(notificationId))
        .then((response) => {
          // console.log('Notification', notificationId);
        })
        .catch((error) => {
          this.props.history.push(
            `/login?path=${this.props.location.pathname}`
          );
          this.props.onLogout();
        });
    } else if (notificationId === "") {
      // console.log('Params', this.props.location.search);
      // this.props.history.push(`/login?path=${this.props.location.pathname}`);
      // this.props.onLogout();
    }
  }

  checkValidation = (org, module) => {
    let { selectModule } = org; 

    if (selectModule) {
      if (module && module.status) {
        if (
          module &&
          (module.isDisplayed || !module.hasOwnProperty("isDisplayed"))
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } else {
      if (
        module &&
        (module.isDisplayed || !module.hasOwnProperty("isDisplayed"))
      ) {
        // console.log('262')
        return true;
      } else {
        // console.log('265')
        return false;
      }
    }
  };
  handleBeforeUnload = (event) => {
    // event.preventDefault();

    if (this.props.returnUrlAfterSlackOrTeamsAuth) {
      this.props.setReturnUrlAfterSlackTeamsAuth(null);
    }

    if (this.props.afterLoginRedirect) {
      this.props.setAfterLoginUrl(null);
    }
  };
  componentWillUnmount = () => {
    this.props.setLibraryScheduleLoader({
      display: false,
      loaderApiData: null,
      minimize: false,
    });
    this.props.setCreateTrivvyLoader({
      display: false,
      loaderApiData: null,
      minimize: false,
    });
    this.props.setGenerateSummaryLoader({
      display: false,
      loaderApiData: null,
      minimize: false,
    });
    this.props.setCreateLibraryLoader({
      display: false,
      loaderApiData: null,
      minimize: false,
    });

    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  };

  renderRouter = () => {
    let isSetupSkipped = this.props.user.organizationId.isSetupSkipped;
    let { orgAdmin, role, organizationId } = this.props.user;
    let {
      selectModule,
      isCultureApp,
      isPlanning,
      isAnalytics,
      isToolkit,
      isGroups,
    } = organizationId;

    let { publicObj } = this.state;

    let home_url = "/home/stories";

    if (
      organizationId.isSignedUpFromTrivvyWebsite ||
      isTrivvyUrl(organizationId)
    ) {
      home_url = `/home/trivia/${organizationId._id}/list`;
    }

    return (
      <Switch>
        {this.checkValidation(organizationId, isCultureApp) && (
          <Route
            render={(props) => (
              <Stories
                key={"cultureApp-archived"}
                {...props}
                value_cat={"archived"}
              />
            )}
            exact
            path={this.props.match.url + "/stories/archived"}
          // component={ArchivedStories}
          // component={Stories}
          />
        )}
        {this.checkValidation(organizationId, isCultureApp) && (
          <Route
            render={(props) => (
              <Stories
                key={"cultureApp-Inbox"}
                {...props}
                value_cat={"inbox"}
              />
            )}
            exact
            path={this.props.match.url + "/stories/inbox"}
          // component={ArchivedStories}
          // component={Stories}
          />
        )}
        {this.checkValidation(organizationId, isCultureApp) && (
          <Route
            render={(props) => (
              <Stories key={"cultureApp-me"} {...props} value_cat={"me"} />
            )}
            exact
            path={this.props.match.url + "/stories/me"}
          // render={props => <Stories value_cat={'me'} />}
          // component={MyStories}
          // component={Stories}
          />
        )}
        {this.checkValidation(organizationId, isCultureApp) && (
          <Route
            render={(props) => (
              <Stories key={"cultureApp-all"} {...props} value_cat={"all"} />
            )}
            exact
            path={this.props.match.url + "/stories"}
          // component={Stories}
          />
        )}
        {this.checkValidation(organizationId, isCultureApp) && (
          <Route
            exact
            path={this.props.match.url + "/stories/trending"}
            component={Trending}
          />
        )}
        {this.checkValidation(organizationId, isCultureApp) && (
          <Route
            exact
            path={this.props.match.url + "/stories/types"}
            component={StoriesTypes}
          />
        )}
        {this.checkValidation(organizationId, isCultureApp) && (
          <Route
            exact
            path={this.props.match.url + "/stories/create/:type"}
            component={StoryCreate}
          />
        )}
        {orgAdmin && (
          <Route
            exact
            path={this.props.match.url + "/stories/reporting"}
            key={"cultureApp-all"}
            value_cat={"all"}
            component={StoryAndComments}
          />
        )}
        <Route
          exact
          path={this.props.match.url + "/stories/:id"}
          component={SingleStory}
        />
        {/* {this.checkValidation(organizationId, isCultureApp) || this.checkValidation(organizationId, isGroups)   && (
          <Route
            exact
            path={this.props.match.url + "/stories/:id"}
            component={SingleStory}
          />
        )} */}
        {/* 
        <Route
          exact
          path={this.props.match.url + "/expand/dani"}
          render={(props) => <Dani {...props} renderInPage />}
        />
        */}

        {this.checkValidation(organizationId, isGroups) && (
          <Route
            exact
            path={this.props.match.url + "/groups/metrics"}
            component={Metrics}
          />
        )}

        {this.checkValidation(organizationId, isGroups) && (
          <Route
            exact
            path={this.props.match.url + "/groups/:orgId/discover"}
            render={(props) => (
              <GroupList key={props.match.params.id} {...props} />
            )}
          />
        )}

        {this.checkValidation(organizationId, isGroups) && (
          <Route
            exact
            path={this.props.match.url + "/groups/:orgId/archived"}
            render={(props) => (
              <GroupList key={props.match.params.id} {...props} />
            )}
          />
        )}

        {this.checkValidation(organizationId, isGroups) && (
          <Route
            exact
            path={this.props.match.url + "/groups/:orgId/feed"}
            render={(props) => (
              <GroupList key={props.match.params.id} {...props} />
            )}
          />
        )}

        {this.checkValidation(organizationId, isGroups) && (
          <Route
            exact
            path={this.props.match.url + "/groups/:orgId/create"}
            render={(props) => (
              <CreateGroup key={props.match.params.id} {...props} />
            )}
          />
        )}

        {this.checkValidation(organizationId, isGroups) && (
          <Route
            path={this.props.match.url + "/groups/:orgId/view/:id"}
            render={(props) => (
              <SingleGroup key={props.match.params.id} {...props} />
            )}
          />
        )}

        <Route
          exact
          path={this.props.match.url + "/notifications"}
          component={Notifications}
        />
        <Route
          exact
          path={this.props.match.url + "/announcements"}
          component={Announcements}
        />

        <Route
          exact
          path={this.props.match.url + "/profile"}
          component={UserProfile}
        />
        <Route
          exact
          path={this.props.match.url + "/profile/events"}
          component={UserProfile}
        />
        <Route
          exact
          path={this.props.match.url + "/profile/my-trivvys"}
          component={UserProfile}
        />

        {/* <Route exact path={this.props.match.url + '/:orgId/profile/:id'} component={OfficeMateProfile}/> */}
        <Route
          exact
          path={this.props.match.url + "/:orgId/profile/:id"}
          render={(props) => (
            <OfficeMateProfile key={props.match.params.id} {...props} />
          )}
        />
        <Route
          exact
          path={this.props.match.url + "/:orgId/profile/:id/events"}
          render={(props) => (
            <OfficeMateProfile key={props.match.params.id} {...props} />
          )}
        />
        <Route
          exact
          path={this.props.match.url + "/:orgId/profile/:id/metrics"}
          render={(props) => (
            <OfficeMateProfile key={props.match.params.id} {...props} />
          )}
        />
        <Route
          exact
          path={this.props.match.url + "/:orgId/profile/:id/my-trivvys"}
          render={(props) => (
            <OfficeMateProfile key={props.match.params.id} {...props} />
          )}
        />
        <Route
          exact
          path={this.props.match.url + "/:orgId/profile/:id/my-messages"}
          render={(props) => (
            <OfficeMateProfile key={props.match.params.id} {...props} />
          )}
        />
        <Route
          exact
          path={this.props.match.url + "/:orgId/profile/:id/pending-trivvys"}
          render={(props) => (
            <OfficeMateProfile key={props.match.params.id} {...props} />
          )}
        />

        {/* <Route exact path={this.props.match.url + '/:orgId/profile/:id/events'} component={OfficeMateProfile}/> */}

        {/* <Route exact path={this.props.match.url + '/office/office-mates/profile'} component={OfficeMateProfile}/>
                    <Route exact path={this.props.match.url + '/:orgId/profile/:id'} component={ProfilePage}/> */}

        {this.checkValidation(organizationId, isPlanning) && (
          <Route
            exact
            path={this.props.match.url + "/enterprise-objective"}
            component={EnterpriseObjective}
          />
        )}
        {this.checkValidation(organizationId, isPlanning) && (
          <Route
            exact
            path={this.props.match.url + "/enterprise-associatedActions/:id"}
            component={EnterpriseAssociatedActions}
          />
        )}
        {this.checkValidation(organizationId, isPlanning) && (
          <Route
            exact
            path={this.props.match.url + "/planning/:id"}
            component={SingleTask}
          />
        )}
        {this.checkValidation(organizationId, isPlanning) && (
          <Route
            exact
            path={this.props.match.url + "/my-activity"}
            component={WeeklyWins}
          />
        )}
        {this.checkValidation(organizationId, isPlanning) && (
          <Route
            exact
            path={this.props.match.url + `/${publicObj.link}`}
            component={AllActions}
          />
        )}
        {this.checkValidation(organizationId, isPlanning) && (
          <Route
            render={(props) => <AllActions {...props} isArchived={true} />}
            exact
            path={this.props.match.url + `/archived-activity`}
          />
        )}

        {!isSetupSkipped && (
          <Route
            exact
            path={this.props.match.url + "/dashboard-list/:orgId"}
            component={DashboardList}
          />
        )}

        {!isSetupSkipped && (
          <Route
            exact
            path={this.props.match.url + "/dashboard/:orgId/view/:id"}
            render={(props) => (
              <DashboardCreate key={props.match.params.id} {...props} />
            )}
          />
        )}

        {!isSetupSkipped &&
          this.checkValidation(organizationId, isAnalytics) && (
            <Route
              exact
              path={this.props.match.url + "/analytics/:orgId/view/:id"}
              component={ViewChart}
            />
          )}
        {!isSetupSkipped &&
          this.checkValidation(organizationId, isAnalytics) && (
            <Route
              exact
              path={this.props.match.url + "/analytics/choose-category"}
              component={ChooseAnalyticsCategory}
            />
          )}
        {!isSetupSkipped &&
          this.checkValidation(organizationId, isAnalytics) && (
            <Route
              exact
              path={this.props.match.url + "/analytics/:category/create"}
              component={CreateChart}
            />
          )}
        {!isSetupSkipped &&
          this.checkValidation(organizationId, isAnalytics) && (
            <Route
              exact
              path={this.props.match.url + "/analytics/:category/edit"}
              component={CreateChart}
            />
          )}
        {!isSetupSkipped &&
          this.checkValidation(organizationId, isAnalytics) && (
            <Route
              exact
              path={this.props.match.url + "/analytics/:category"}
              component={ChartList}
            />
          )}

        <Route exact path={this.props.match.url + "/users"} component={Users} />
        <Route
          exact
          path={this.props.match.url + "/users/invite"}
          component={InviteOfficeMates}
          {...this.props}
        />
        <Route
          exact
          path={this.props.match.url + "/import-history"}
          component={ImportHistory}
        />
        <Route
          exact
          path={this.props.match.url + "/metaData-history"}
          component={MetaDataHistory}
        />
        <Route exact path={this.props.match.url + "/help"} component={Help} />
        <Route exact path={this.props.match.url + "/diversity-calendar"} component={DiversityCalendar} />
        <Route path={this.props.match.url + "/dei-maturity-model"} component={DEIMaturityModel} />
        <Route exact path={this.props.match.url + "/terms"} component={Terms} />
        <Route exact path={this.props.match.url + "/dani/terms"} component={DaniTerms} />
        <Route exact path={this.props.match.url + "/dani/support"} component={SupportPage} />
        <Route exact path={this.props.match.url + "/dani/data-policies"} component={DataPolicies} />
        <Route exact path={this.props.match.url + "/dani/slack-app-install"} component={DaniLandingPage} />
        <Route
          exact
          path={this.props.match.url + "/news"}
          render={() => <div>News</div>}
        />

        <Route
          exact
          path={this.props.match.url + "/enterprise/org-chart"}
          component={OrgChartManagement}
        />
        <Route
          exact
          path={this.props.match.url + "/office-info"}
          component={OfficeInformation}
        />
        {orgAdmin && (
          <Route
            exact
            path={this.props.match.url + "/enterprise-info"}
            component={EnterpriseInformation}
          />
        )}
        {orgAdmin && (
          <Route
            exact
            path={this.props.match.url + "/enterprise-info/review-existing"}
            render={(props) => <ReviewExistingMappingManagement {...props} />}
          />
        )}
        {orgAdmin && (
          <Route
            exact
            path={this.props.match.url + "/enterprise-info/org-chart"}
            component={ImportOfficeHierarchy}
          />
        )}
        {orgAdmin && (
          <Route
            exact
            path={
              this.props.match.url +
              "/enterprise-info/org-chart/management/edit"
            }
            component={ChangeOfficeHierarchy}
          />
        )}
        {orgAdmin && (
          <Route
            exact
            path={
              this.props.match.url +
              "/enterprise-info/org-chart/management/success"
            }
            component={ChangeOfficeSuccess}
          />
        )}

        {orgAdmin && (
          <Route
            exact
            path={
              this.props.match.url + "/enterprise-info/org-chart/management"
            }
            component={OfficeHierarchyManagement}
          />
        )}
        {orgAdmin && (
          <Route
            exact
            path={
              this.props.match.url +
              "/enterprise-info/org-chart/management/review"
            }
            component={OfficeHierarchyManagementReview}
          />
        )}
        {orgAdmin && (
          <Route
            exact
            path={this.props.match.url + "/enterprise-info/map-gender"}
            render={(props) => <MapGenderManagement {...props} />}
          />
        )}
        {orgAdmin && (
          <Route
            exact
            path={this.props.match.url + "/enterprise-info/map-positions"}
            component={MapPositionsManagement}
          />
        )}
        {orgAdmin && (
          <Route
            exact
            path={this.props.match.url + "/enterprise-info/map-performance"}
            component={MapPerformanceManagement}
          />
        )}
        {orgAdmin && (
          <Route
            exact
            path={this.props.match.url + "/enterprise-info/map-ethnicity"}
            component={MapEthnicityManagement}
          />
        )}
        {orgAdmin && (
          <Route
            exact
            path={this.props.match.url + "/enterprise-info/map-veteran"}
            component={MapVeteranManagement}
          />
        )}
        {orgAdmin && (
          <Route
            exact
            path={
              this.props.match.url + "/enterprise-info/map-sexual-orientation"
            }
            component={MapSexualOrientationManagement}
          />
        )}
        {orgAdmin && (
          <Route
            exact
            path={this.props.match.url + "/enterprise-info/map-religion"}
            component={MapReligionManagement}
          />
        )}
        {orgAdmin && (
          <Route
            exact
            path={this.props.match.url + "/enterprise-info/map-disability"}
            component={MapDisabilityManagement}
          />
        )}
        {orgAdmin && (
          <Route
            exact
            path={this.props.match.url + "/enterprise-info/map-separation"}
            component={MapSeparationManagement}
          />
        )}
        {orgAdmin && (
          <Route
            exact
            path={this.props.match.url + "/enterprise-info/success"}
            component={MapSuccessManagement}
          />
        )}
        <Route
          exact
          path={this.props.match.url + "/office/office-mates"}
          component={OfficeMates}
        />
        {this.checkValidation(organizationId, isAnalytics) && (
          <Route
            exact
            path={this.props.match.url + "/upload-data"}
            component={ChooseUploadCategory}
          />
        )}
        {this.checkValidation(organizationId, isAnalytics) && (
          <Route
            exact
            path={this.props.match.url + "/upload-data/csv"}
            component={CsvUpload}
          />
        )}
        {this.checkValidation(organizationId, isAnalytics) && (
          <Route
            exact
            path={this.props.match.url + "/upload-data/success"}
            component={UploadSuccess}
          />
        )}
        {this.checkValidation(organizationId, isAnalytics) && (
          <Route
            exact
            path={this.props.match.url + "/upload-data/manual"}
            component={ManualDataEntry}
          />
        )}

        {this.checkValidation(organizationId, isToolkit) && (
          <Route
            exact
            path={this.props.match.url + "/toolkit/choose-category"}
            component={ChooseToolkitCategory}
          />
        )}
        {this.checkValidation(organizationId, isToolkit) && (
          <Route
            exact
            path={this.props.match.url + "/toolkit/:category/add"}
            component={AddToolkit}
          />
        )}
        {this.checkValidation(organizationId, isGroups) && (
          <Route
            exact
            path={this.props.match.url + "/toolkit/:groupId/:category/add"}
            component={AddToolkit}
          />
        )}
        {this.checkValidation(organizationId, isGroups) && (
          <Route
            exact
            path={this.props.match.url + "/toolkit/:groupId/:category/tool/:id"}
            component={ToolDetails}
          />
        )}

        {(this.checkValidation(organizationId, isToolkit) ||
          this.checkValidation(organizationId, isGroups)) && (
            <Route
              exact
              path={this.props.match.url + "/toolkit/:category/edit/:tool"}
              component={EditToolkit}
            />
          )}
        {this.checkValidation(organizationId, isGroups) && (
          <Route
            exact
            path={
              this.props.match.url + "/toolkit/:groupId/:category/edit/:tool"
            }
            component={EditToolkit}
          />
        )}
        {(this.checkValidation(organizationId, isToolkit) ||
          this.checkValidation(organizationId, isGroups)) && (
            <Route
              exact
              path={this.props.match.url + "/toolkit/:category/tool/:id"}
              component={ToolDetails}
            />
          )}
        {this.checkValidation(organizationId, isToolkit) && (
          <Route
            exact
            path={
              this.props.match.url + "/toolkit/:category/tool/:orgId/view/:id"
            }
            component={ToolDetails}
          />
        )}
        {this.checkValidation(organizationId, isToolkit) && (
          <Route
            exact
            path={this.props.match.url + "/toolkit/:category/preview"}
            component={ToolPreview}
          />
        )}

        {(this.checkValidation(organizationId, isToolkit) || this.checkValidation(organizationId, isGroups)) && (
          <Route
            exact
            path={this.props.match.url + "/toolkit/:category"}
            component={ToolkitCategory}
          />
        )}



        {orgAdmin && (
          <Route
            exact
            path={this.props.match.url + "/dashboard/overview"}
            component={Analytics}
          />
        )}
        {(orgAdmin || this.props.user.role === "Admin") && (
          <Route
            exact
            path={this.props.match.url + "/dashboard/users"}
            component={UserAnalytics}
          />
        )}
        {orgAdmin && (
          <Route
            exact
            path={this.props.match.url + "/dashboard/tools"}
            component={AnalyticsToolKit}
          />
        )}
        {orgAdmin && (
          <Route
            exact
            path={this.props.match.url + "/dashboard/charts"}
            component={AnalyticsCharts}
          />
        )}
        {orgAdmin && (
          <Route
            exact
            path={this.props.match.url + "/dashboard/actions"}
            component={ActionAnalytics}
          />
        )}
        {(orgAdmin || this.props.user.role === "Admin") && (
          <Route
            exact
            path={this.props.match.url + "/dashboard/stories"}
            component={StoriesAnalytics}
          />
        )}

        <Route
          exact
          path={this.props.match.url + "/no-data"}
          component={NoData}
        />
        {/* <Redirect to={this.props.match.url + '/stories'}/> */}
        {/* <Route
          exact
          path={this.props.match.url + "/survey"}
          component={Survey}
        /> */}
        <Route
          exact
          path={this.props.match.url + "/trivia/:orgId/edit/:id/:tab"}
          component={TriviaEdit}
        />
        <Route
          exact
          path={
            this.props.match.url + "/trivia/:orgId/library-item/:id/view/:tab"
          }
          component={TriviaLibraryViewPage}
        />
        <Route
          exact
          path={this.props.match.url + "/trivia/:orgId/quiz/:surveyId/:block"}
          component={TriviaQuizPage}
        />
        <Route
          exact
          path={
            this.props.match.url +
            "/trivia/:orgId/preview-quiz/:surveyId/:block"
          }
          component={PreviewQuizPage}
        />
        <Route
          // exact
          path={this.props.match.url + "/trivia/:orgId"}
          // component={TriviaContainer}
          render={(props) => (
            <TriviaContainer key={props.match.params.tab} {...props} />
          )}
        />

        {/* <Route exact path={this.props.match.url + "/survey"} component={Survey} /> */}
        {/* element={ <Redirect to="/error-page" /> } */}

        <Redirect
          from="/home/undefined"
          to={
            "/home" +
            `/${this.props.user.organizationId._id}/profile/${this.props.user._id}`
          }
        />
        <Redirect from="/home" to={home_url} />
        <Redirect
          to={
            this.props.match.url +
            navigate_user_to_module(
              this.props.user.organizationId,
              true,
              this.props.user.orgAdmin
            )
          }
        />

        <Redirect
          from="*"
          to={
            "/home" +
            navigate_user_to_module(
              this.props.user.organizationId,
              true,
              this.props.user.orgAdmin
            )
          }
        />
      </Switch>
    );
  };

  renderStandardSideBar = () => {
    let { user } = this.props;
    let url = this.props.location.pathname;

    if (!isMobile) {
      if (user) {
        if (!custom_views(url, user)) {
          return this.renderSideBar();
        }
        // if( user.organizationId._id!="5c421da6363d02090ea4b9aa"){

        // }
      }
    }
  };

  renderSideBar = () => {
    return <SideBar {...this.props} />;
  };

  renderActivityBar = () => {
    return <ActivityBar {...this.props} />;
  };

  renderMainContainer = () => {
    let isStories =
      (this.props &&
        this.props.location &&
        this.props.location.pathname.indexOf("/home/stories") > -1) ||
        this.props.location.pathname.indexOf("/home/reporting/story-comment") > -1
        ? true
        : false;
    let url = this.props.location.pathname;
    let { user } = this.props;
    if (!isMobile) {
      if (isStories) {
        return `col-md-6 col-lg-6 ml-sm-auto mainPadding`;
      } else if (user && custom_views(url, user)) {
        return `col-md-12 col-sm-12 ml-sm-auto px-0 pt-0 ${!isMobile && ""}`;
      } else {
        if (isTrivvyUrl(user.organizationId)) {
          return `col-md-10 col-sm-10 ml-sm-auto ${!isMobile && ""}`;
        }
        return `col-md-10 col-sm-10 pt-0 ml-sm-auto ${!isMobile && ""}`;
      }
    }
  };

  renderView = () => {
    let isSignedUpFromTrivvy = false;

    if (
      this.props.user &&
      this.props.user.organizationId &&
      this.props.user.organizationId
    ) {
      let {
        whiteLabel,
        name,
        isSignedUpFromTrivvyWebsite,
      } = this.props.user.organizationId;

      if (isSignedUpFromTrivvyWebsite || isTrivvyProduct()) {
        isSignedUpFromTrivvy = true;
      }

      if (whiteLabel && whiteLabel.logo && whiteLabel.logo.url) {
        let imageSrc = whiteLabel.logo.url;
        // let imageSrc = "https://prod-oo-app-attachment.s3.us-east-2.amazonaws.com/org/1687279352948-lg";
        let faviconImg = document.querySelector("#favicon");
        resizeImageFromUrl(imageSrc, 200, 200, (data) => {
          faviconImg.setAttribute("href", data);
        });

        let htmlTitle = document.querySelector(".html-tab-title");
        htmlTitle.innerText = name;
      } else {
        if (isSignedUpFromTrivvy) {
          let faviconImg = document.querySelector("#favicon");
          resizeImageFromUrl(trivvyLogo, 200, 200, (data) => {
            faviconImg.setAttribute("href", data);
          });
        }
      }

      if (whiteLabel && Object.values(whiteLabel).length > 0) {
        let htmlTitle = document.querySelector(".html-tab-title");
        htmlTitle.innerText = name;
      } else {
        if (isSignedUpFromTrivvy) {
          let htmlTitle = document.querySelector(".html-tab-title");
          htmlTitle.innerText = "Trivvy";
        }
      }
    }

    let { publicObj } = this.state;

    let isStories =
      this.props &&
        this.props.location &&
        (this.props.location.pathname.indexOf("/home/stories") > -1 ||
          this.props.location.pathname.indexOf("/home/reporting") > -1)
        ? true
        : false;

    let isReporting =
      this.props &&
      this.props.location &&
      this.props.location.pathname.indexOf("/home/reporting/story-comment") >
      -1;

    let isPlanningView =
      this.props &&
        this.props.location &&
        this.props.location.pathname.indexOf("/home/my-activity") > -1
        ? true
        : false;

    let dashboardView =
      this.props &&
        this.props.location &&
        this.props.location.pathname.indexOf("/home/dashboard") > -1
        ? true
        : false;

    if (!isPlanningView) {
      isPlanningView =
        this.props &&
          this.props.location &&
          this.props.location.pathname.indexOf(`/home/${publicObj.link}`) > -1
          ? true
          : false;
      if (!isPlanningView) {
        isPlanningView =
          this.props &&
            this.props.location &&
            this.props.location.pathname.indexOf(`/home/archived-activity`) > -1
            ? true
            : false;
      }
    }

    let isGroupsView =
      this.props &&
        this.props.location &&
        (this.props.location.pathname.indexOf("/home/groups") > -1 ||
          this.props.location.pathname.indexOf("/home/trivia") > -1)
        ? true
        : false;
    let isSetupSkipped = this.props.user.organizationId.isSetupSkipped;
    let isReportsPreview =
      this.props &&
        this.props.location &&
        this.props.location.pathname.indexOf(
          `dashboard/${this.props.user.organizationId._id}/report-preview`
        ) > -1
        ? true
        : false;
    let url = this.props.location.pathname;
    let { user } = this.props;

    const isDaniPage =
      this.props.location.pathname.indexOf("/expand/dani") > -1;

    if (isReportsPreview == 100000) {
      // return <Route exact path={this.props.match.url + '/dashboard/:orgId/report-preview/:id'} render={(props) => <ReportLayout  key={props.match.params.id} {...props}/>} />
    } else {
      if (isDaniPage && !isTrivvyUrl()) {
        return <Dani {...this.props} renderInPage />;
      } else {
        return (
          // add custom background-image here for organization with class org_background_image_css
          <div className={``}>
            <NavBar {...this.props} />
            {/* pb150 */}
            <div
              className={
                custom_views(url, user)
                  ? ""
                  : `container-fluid ${isMobile ? "pb55" : isStories ? "" : ""
                  } ${isPlanningView ? "pl01Lcss" : ""} ${dashboardView ? "db01Lcss" : ""
                  } ${isStories ? "stories-page-width" :""} generalPageStyle`
              }
            >
              <div className={isGroupsView && isMobile ? "" : (isStories && isMobile) ? "": "row"}>
                {this.renderStandardSideBar()}

                <main role="main" className={this.renderMainContainer()}>
                  {this.renderRouter()}
                </main>

                {!isMobile && isStories ? (
                  <div className="col-md-3 col-lg-3 rightSideBar">
                    {!isReporting && this.renderActivityBar()}
                  </div>
                ) : null}
              </div>
            </div>

            {!isMobile &&
              !isSignedUpFromTrivvy &&
              !isTrivvyUrl() &&
             
              this.props.location.pathname.indexOf("/expand/dani") < 0 && this.props.location.pathname.indexOf("/analytics") >= 0 && (
                <Dani {...this.props} />
              )}

            {this.props.libraryScheduleTrivvyLoader &&
              this.props.libraryScheduleTrivvyLoader.display ? (
              <SchedultTrivvyLoaderBox
                loaderApiData={
                  this.props.libraryScheduleTrivvyLoader.loaderApiData
                }
              />
            ) : null}
            {this.props.createTrivvyLoader &&
              this.props.createTrivvyLoader.display ? (
              <CreateTrivvyLoaderBox
                loaderApiData={this.props.createTrivvyLoader.loaderApiData}
              />
            ) : null}
            {this.props.generateSummaryLoader &&
              this.props.generateSummaryLoader.display ? (
              <GenerateSummaryLoaderBox
                loaderApiData={this.props.generateSummaryLoader.loaderApiData}
              />
            ) : null}

            {this.props.createLibraryLoader &&
              this.props.createLibraryLoader.display ? (
              <CreateLibraryLoaderBox
                loaderApiData={this.props.createLibraryLoader.loaderApiData}
              />
            ) : null}

            <If condition={isMobile}>
              <Detector
                render={({ online }) =>
                  !online && (
                    <div className=" network-status network-error vertical-middle">
                      You're offline right now.
                      <br /> Check your connection.
                    </div>
                  )
                }
              />
            </If>
          </div>
        );
      }
    }
  };

  render() {
    return this.renderView();
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user.profile,
    toolkitCategories: state.toolkit.category,
    analyticsCategories: state.analytics.category,
    currentTool: state.toolkit.toolDetails,
    currentChart: state.analytics.chartDetails,
    reportingCategories: state.reporting.category,
    returnUrlAfterSlackOrTeamsAuth: state.user.returnUrlAfterSlackOrTeamsAuth,
    libraryScheduleTrivvyLoader: state.trivia.libraryScheduleTrivvyLoader || {
      display: false,
    },
    createTrivvyLoader: state.trivia.createTrivvyLoader || { display: false },
    generateSummaryLoader: state.trivia.generateSummaryLoader || {
      display: false,
    },
    createLibraryLoader: state.trivia.createLibraryLoader || {
      display: false,
    },
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onLogout: () => dispatch(actionCreators.logout()),
    setReturnUrlAfterSlackTeamsAuth: (data) =>
      dispatch(actionCreators.setReturnUrlAfterSlackTeamsAuth(data)),
    orgChangeSuccess: (data) => dispatch(actionCreators.orgChangeSuccess(data)),
    setImportTemplateAddedTrivvys: (data) =>
      dispatch(actionCreators.setImportTemplateAddedTrivvys(data)),
    setCreateModalState: (data) =>
      dispatch(actionCreators.setCreateModalState(data)),
    updateUserSuccess: (data) =>
      dispatch(actionCreators.updateUserSuccess(data)),
    setLibraryScheduleLoader: (data) =>
      dispatch(actionCreators.setLibraryScheduleLoader(data)),
    setCreateTrivvyLoader: (data) =>
      dispatch(actionCreators.setCreateTrivvyLoader(data)),
    setGenerateSummaryLoader: (data) =>
      dispatch(actionCreators.setGenerateSummaryLoader(data)),
    setCreateLibraryLoader: (data) =>
      dispatch(actionCreators.setCreateLibraryLoader(data)),
    setAfterLoginUrl: (data) =>
      dispatch(actionCreators.setAfterLoginUrl(data)),
    setAfterLoginUrl: (data) => dispatch(actionCreators.setAfterLoginUrl(data)),
    updateSelectedDate: (data) => dispatch(actionCreators.updateSelectedDate(data)),//update MM selected date
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AdminHome)
);
